import { useQuery } from 'react-query';

import { partnerLinkApiClient } from 'app/api/v2/api_calls/apiResources';
import { PARTNER_LINKS } from 'app/common/data/queryKeysConstants';

export default function usePartnerLinks() {
    return useQuery([PARTNER_LINKS], partnerLinkApiClient.getPartnerLinks);
}
